import { create } from 'zustand';

export const useUserStore = create((set) => ({
  currentUser: null,
  setCurrentUser: (currentUser) => set({ currentUser }),
  resetUser: () => set({ currentUser: null })
}));
